import { render, staticRenderFns } from "./addAccount.vue?vue&type=template&id=c6eb7230"
import script from "./addAccount.vue?vue&type=script&lang=js"
export * from "./addAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports